import React from 'react'
import { DealsTable } from 'components/Tables/DealsTable/DealsTable'
import { ContactCompany } from 'models/companies'
import { CompanyModal } from '../CompanyModal'
import { TableLinkStyleProvider } from 'components/Tables/CommonTableCells/TableLinkStyleContext'
import { StageColorProvider } from 'components/SalesStage/StageColorContext'

interface DealsModalProps {
  show: boolean
  onHide: () => void
  contactCompany: ContactCompany
  forDoorProxyId?: number
  companyName?: string
}

export function DealsModal({
  show,
  onHide,
  contactCompany,
  forDoorProxyId,
  companyName,
}: DealsModalProps) {
  const TABLE_KEY = forDoorProxyId
    ? `deals-modal-door-${forDoorProxyId}`
    : `deals-modal-company-${contactCompany.id}`

  return (
    <CompanyModal
      show={show}
      onHide={onHide}
      companyName={companyName || contactCompany.name}
      modalTitle="Deals"
    >
      <TableLinkStyleProvider variant="plain">
        <StageColorProvider value="pipeline">
          <div
            className="flex flex-col overflow-hidden rounded-lg border border-neutral-200 bg-white shadow-[0px_1px_3px_0px_rgba(16,24,40,0.08),0px_1px_2px_-1px_rgba(16,24,40,0.04)]"
            style={{ height: '60vh' }}
          >
            <DealsTable
              useReports={true}
              tableKey={TABLE_KEY}
              forCompany={contactCompany as any}
              forDoorProxyId={forDoorProxyId}
              enablePagination={true}
              disableUrlPagination
              showCompanyColumn={false}
              defaultColumnVisibility={{ identifier: false }}
            />
          </div>
        </StageColorProvider>
      </TableLinkStyleProvider>
    </CompanyModal>
  )
}
